import { MapFilter } from "../MapFilter";
import { ZipCode } from "../ZipCode";
import { ICacheStorage } from "./ICacheStorage";

export class ZipCodesCacheStorage implements ICacheStorage<ZipCode> {
    private readonly storage: Map<string, ZipCode[]>;

    public constructor() {
        this.storage = new Map<string, ZipCode[]>();
    }
    
    public cacheData(filter: MapFilter, zipCodes: ZipCode[], force: boolean = false): void {
        const key = this.constructKey(filter);
        if (this.storage.has(key) && !force) {
            return;
        }
        this.storage.set(key, zipCodes);
    }

    public getCachedData(filter: MapFilter): ZipCode[] {
        const key = this.constructKey(filter);
        return  this.storage.has(key) ? this.storage.get(key) : [];
    }

    private constructKey(filter: MapFilter): string {
        return `area-${filter.area}`;
    }
}
